

import { addToCart, getCurrentCart } from '@process-creative/pc-slate-tools';
import $ from 'jquery';
import { CarouselSection } from '../carousel/CarouselSection';


export const UPSELL_CONTAINER_SELECTOR = '[data-upsell-recommendations]';
export const UPSELL_CAROUSEL_SELECTOR = '[data-upsell-recommendations-slider]';

class UpsellCarousel extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselContainer = container.find(UPSELL_CAROUSEL_SELECTOR);
    this.slick = this.initCarousel(this.carouselContainer)
  }

  reset(newMarkup) {
    if (this.slick) {
      this.slick[0].slick.destroy();
    }

    this.carouselContainer[0].innerHTML = newMarkup;
    this.slick = this.initCarousel(this.carouselContainer);
  }

  optionOverrides() {
    return {
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      appendArrows: $('[data-upsell-recommendations-arrows]'),
      dots: true,
      appendDots: $('[data-upsell-recommendations-dots]'),
      responsive: [
        // Need to have an array of responsive stuff, even if you don't need it
        // removing array breaks the carousel
      ]
    }
  }
}


const getUpsellRecco = async () => {
  return await fetch('/cart?view=json').then(res => res.json());
}

const upsellItemTemplate = (itemData) => {
  return `
    <div class="o-cart-upsell__item">
      <a href="${itemData.product_url}" class="o-cart-upsell__item-link">
        <img src="${itemData.image}" class="o-cart-upsell__item-image">
      </a>
      <div class="o-cart-upsell__item-data">
        <p class="o-cart-upsell__item-type o-small">${itemData.product_type}</p>
        <p class="o-cart-upsell__item-title o-heading">${itemData.title}</p>
        <p class="o-cart-upsell__item-price o-heading">${itemData.price}</p>
      </div>
      
      <div class="o-cart-upsell__item-btn">
        <p class="o-cart-upsell__item-price o-heading">${itemData.price}</p>
        <button class="o-cart-upsell__item-add o-heading" data-variant-id="${itemData.variant_id}">
          <span class="o-cart-upsell__item-add-text">Add </span>
          <span class="o-cart-upsell__item-add-icon">+</span>
          <span class="o-cart-upsell__item-add-loader"></span>
        </button>
      </div>
    </div>
  `
}

export default class CartUpsells {

  constructor(container) {
    const cartUpsellSection = document.querySelector(UPSELL_CONTAINER_SELECTOR); 
    this.cartUpsellSection = cartUpsellSection;
    this.nextIcon = cartUpsellSection.querySelector('[data-upsell-recommendations-next]');
    this.prevIcon = cartUpsellSection.querySelector('[data-upsell-recommendations-prev]');
    this.navigationDots = cartUpsellSection.querySelector('[data-upsell-recommendations-dots]');
    this.sliderElement = cartUpsellSection.querySelector('[data-upsell-recommendations-slider]');

    this.sliderElement.addEventListener('click', this.addToCart.bind(this));
    
    const carouselContainer = $(UPSELL_CONTAINER_SELECTOR);
    if (carouselContainer) {
      this.carousel = new UpsellCarousel(carouselContainer);
      this.update();
    }

    // trigger a window resize event so then Slick will recalculate all the internal widths
    // Slick doesn't do this initially.
    window.dispatchEvent(new Event('resize'));

  }

  async update() {
    const { items: currentCartItems } = getCurrentCart();
    const cartItemHandles = currentCartItems.map(prod => prod.handle);
    const upsellRecommendations = await getUpsellRecco();
    const removedCommonProducts = upsellRecommendations.filter(recco => {
      return !cartItemHandles.includes(recco.handle);
    });

    const upsellItemMarkup = removedCommonProducts.map(upsellItemTemplate).join('');
    
    this.carousel.reset(upsellItemMarkup);
    this.cartUpsellSection.classList[removedCommonProducts.length ? 'add' : 'remove']('is-active');

  }

  addToCart(e) {    
    const productClicked = e.composedPath().find(el => el.dataset?.variantId);
    if (!productClicked) return;

    productClicked.classList.add('loading');

    const variantId = parseInt(productClicked.dataset.variantId);
    if (variantId) addToCart(variantId, 1, {});
  }

}
